__turbopack_context__.v({
  "icon": "iXGiaq_icon",
});
